import { createClient, safeRequest } from '../clientConfiguration';

export const pnosApiClient = createClient({
  baseURL: '/rest-api/phone-number',
});

export const getPhoneNumber = (corpAcctNbr: number, phoneNumber: number) => {
  return safeRequest(() =>
    pnosApiClient.get(
      `/v3/corp-account/${corpAcctNbr}/phone-numbers/${phoneNumber}`,
    ),
  );
};

export const enableSMS = (phoneNumber: string, corpAcctNbr: number) => {
  return pnosApiClient.post(
    `/v3/corp-account/${corpAcctNbr}/phone-numbers/${phoneNumber}/enable-mms?isUser=false`,
  );
};

export const disableSMS = (phoneNumber: string, corpAcctNbr: number) => {
  return pnosApiClient.delete(
    `/v3/corp-account/${corpAcctNbr}/phone-numbers/${phoneNumber}/enable-mms?isUser=false`,
  );
};

export const getPhoneNumberByCarrier = (
  corpAcctNbr: number,
  carrier: string,
) => {
  return safeRequest(() =>
    pnosApiClient.get(`/v2/phone-numbers/${corpAcctNbr}/${carrier}/available`),
  );
};

export const enableSmsSoleProprietor = (
  corpAcctNbr: number,
  phoneNumber: string,
) => {
  return pnosApiClient.post(
    `/v3/corp-account/${corpAcctNbr}/phone-numbers/${phoneNumber}/enable-mms/sole-proprietor?isUser=true`,
  );
};

export const getPhoneNumberSoleProprietor = (corpAcctNbr: number) => {
  return safeRequest(() =>
    pnosApiClient.get(
      `/v3/corp-account/${corpAcctNbr}/phone-numbers/enable-mms/sole-proprietor`,
    ),
  );
};
